export const setActionUrgency = ({
  change,
  isPriority,
  fieldName = 'urgency'
}) => change(fieldName, isPriority ? 'priority' : 'normal');
